import { Box } from "@mui/material";
import { classes } from "./loading-placeholder.styles";

export const Loader = ({ size = 45 }: { size?: number }) => {
  return <Box sx={{ ...classes.loader, height: size, width: size }}></Box>;
};

export const LoadingPlaceholder = () => {
  return (
    <Box sx={classes.root} id="loading">
      <Loader />
    </Box>
  );
};
